import yup from "./yup";

export const passwordSchema = yup.object().shape({
    OldPassword:
        yup.string().label('Contraseña').required(),
    NewPassword:
        yup.string().min(6)
            .label('Nueva contraseña')
            .required(),
    passwordConfirm:
        yup.string().label('Confirmar contraseña')
            .oneOf([yup.ref('NewPassword'), null], "Las Contraseñas no coinciden")
            .required(),
});